import site from './modules/site'
import biz1 from './modules/biz1'
import customer from './modules/customer'
import store from './modules/store'
import member from './modules/member'
import appoint from './modules/appoint'
import contract from './modules/contract'
import order from './modules/order'
import bill from './modules/bill'
import report from './modules/report'
import bc from './modules/bc'
import splitAcc from './modules/splitAcc'


/**
 * 当前目录下的 modules 文件夹中，存放所有的业务模块所相关的 ajax api 路径。
 * site 与 biz1 为两个示例业务模块。
 *
 * ajax 调用示例：
 * _api.site.getUserInfo({
 *    // params...
 * }).then(result=>{
 *    // 回调
 * })
 *
 * 注意：
 * 1. 导出的模块名字必须与文件名一致。
 * 2. _api 为全局变量，直接使用，不需要显式引入。
 */
export default {
  site,
  biz1,
  customer,
  store,
  member,
  appoint,
  contract,
  order,
  bill,
  report,
  bc,
  splitAcc
}
